import React from "react";
import Logo from "../assets/Logo.png";
import facebook from "../assets/facebook.jpeg";
import twitter2 from "../assets/twitter1.png";
// import youtube from "../assets/youtube.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div
      className="container-fluid text-center mt-5"
      style={{
        backgroundColor: " #F7F7F7",
        "--bs-gutter-x": "0rem",
      }}
    >
      <h1 className="p-5 mt-5 fw-semibold footer-title fs-3 fs-md-2">
        Explore Services
      </h1>
      <div className="container">
        <div className="row justify-content-center gap-4">
          <div className="col-12 col-md-3 mb-4 text-center text-md-start">
            <h6 className="fw-bold">Loans</h6>
            <ul className="list-unstyled ">
              <li>
                <Link
                  to="/Individualservice"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Personal Loan
                </Link>
              </li>
              <li>
                <Link to="/homeloan" className="text-decoration-none text-dark hover-underline">
                  Home Loan
                </Link>
              </li>
              <li>
                <Link to="/carloan" className="text-decoration-none text-dark hover-underline">
                  Car Loan
                </Link>
              </li>
              <li>
                <Link
                  to="/educationloan"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Education Loan
                </Link>
              </li>
              <li>
                <Link to="/bikeloan" className="text-decoration-none text-dark hover-underline">
                  Bike Loan
                </Link>
              </li>
              <li>
                <Link
                  to="/businessloan"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Business Loan
                </Link>
              </li>
               <li>
                <Link
                  to="/gold"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Gold Loan
                </Link>
              </li>
              <li>
                <Link to="/property" className="text-decoration-none text-dark hover-underline">
                  Property Loan
                </Link>
              </li>
              <li>
                <Link to="/medical" className="text-decoration-none text-dark hover-underline">
                  Medical Loan
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-12 col-md-3 mb-4 text-center text-md-start">
            <h6 className="fw-bold">Insurance</h6>
            <ul className="list-unstyled">
               <li>
                <Link
                  to="/home"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Home Insurance
                </Link>
              </li>

              <li>
                <Link to="/business" className="text-decoration-none text-dark hover-underline">
                  Business Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/healthinsurance"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Health Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/lifeinsurance"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Life Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/travelinsurance"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Travel Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/bikeinsurance"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Bike Insurance
                </Link>
              </li>
              <li>
                <Link
                  to="/carinsurance"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Car Insurance
                </Link>
              </li>
              <li>
                <Link to="/gadget" className="text-decoration-none text-dark hover-underline">
                  Gadget Insurance
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-12 col-md-3 mb-4 text-center text-md-start ">
            <h6 className="fw-bold">Payments</h6>
            <ul className="list-unstyled">
              <li>
                <Link
                  to="/mobileprepaid"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Mobile Recharge
                </Link>
              </li>
              <li>
                <Link
                  to="/electricity"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Electricity Recharge
                </Link>
              </li>
              <li>
                <Link to="/fastag" className="text-decoration-none text-dark hover-underline">
                  Fastag Recharge
                </Link>
              </li>
              <li>
                <Link to="/dth" className="text-decoration-none text-dark hover-underline">
                  DTH Recharge
                </Link>
              </li>
              <li>
                <Link to="/water" className="text-decoration-none text-dark hover-underline">
                  Water Bill Recharge
                </Link>
              </li>
              <li>
                <Link
                  to="/broadband"
                  className="text-decoration-none text-dark hover-underline"
                >
                  Broadband Recharge
                </Link>
              </li>
               <li>
                <Link to="/pipe" className="text-decoration-none text-dark hover-underline">
                  PipeLine Recharge
                </Link>
              </li>
              <li>
                <Link to="/cablewire" className="text-decoration-none text-dark hover-underline">
                  Cable Recharge
                </Link>
              </li>
              <li>
                <Link to="/gas" className="text-decoration-none text-dark hover-underline">
                  Gas Booking
                </Link>
              </li>
              <li>
                <Link
                  to="/credit-card"
                  className="text-decoration-none text-dark hover-underline"
                >
                  CreditCard Bill
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <footer className="mt-5 m-0">
        <div
          className="col-12 text-white py-5"
          style={{ backgroundColor: " #214163" }}
        >
          <div className="container">
            <div className="row justify-content-center gap-3">
              <div className="col-12 col-md-2 text-center text-md-start mx-auto">
                <Link
                  to="/about"
                  className="fw-semibold text-white text-decoration-none"
                >
                  About us
                </Link>
              </div>
              <div className="col-12 col-md-2 text-center text-md-start mx-auto">
                <Link
                  to="/career"
                  className="fw-semibold text-white text-decoration-none"
                >
                  Careers
                </Link>
              </div>
              <div className="col-12 col-md-2 text-center text-md-start mx-auto">
                <Link
                  to="/all-blogs"
                  className="fw-semibold text-white text-decoration-none"
                >
                  Blogs
                </Link>
              </div>
              <div className="col-12 col-md-2 text-center text-md-start mx-auto">
                <Link
                  to="/contact-us"
                  className="fw-semibold text-white text-decoration-none"
                >
                  Contact us
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="py-4" style={{ backgroundColor: " #E6EFFD" }}>
          <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div className=" mb-md-0 text-center text-md-start">
              <Link className="navbar-brand fw-bold" to="/">
                <img
                  src={Logo}
                  alt="ShubhPaisa Logo"
                  style={{ height: "50px", backgroundColor: "none" }}
                />
              </Link>
              <p
                className="mb-0 mt-4"
                style={{ Color: "#000000", fontSize: "14.2px" }}
              >
                Our goal is to provide easy-to-use, transparent
                <br />
                financial products that cater to the rapidly
                <br />
                evolving financial needs of India.
              </p>
            </div>

            <div className="d-flex gap-3 justify-content-center social-icons mt-4">
              <Link to="/">
                <img src={facebook} alt="Facebook" width="24" height="24" />
              </Link>
              <Link to="/">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/145/145807.png"
                  alt="LinkedIn"
                  width="24"
                  height="24"
                />
              </Link>
              <Link to="/">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                  alt="Instagram"
                  width="24"
                  height="24"
                />
              </Link>
              <Link to="/">
                <img src={twitter2} alt="X (Twitter)" width="24" height="24" />
              </Link>
            </div>
          </div>
        </div>

       <div className="border-top py-3">
  <div className="container d-flex flex-column flex-sm-row justify-content-between align-items-center text-center text-sm-start">
    <div
      className="text-muted mb-2 mb-sm-0"
      style={{
        color: "#000000",
        fontWeight: "400",
        fontFamily: "Poppins",
        fontSize: "15.7px",
      }}
    >
      © 2025 ShubhPaisa Limited
    </div>
    <div>
      <Link
        to="/privacy"
        className="text-muted text-decoration-none d-block d-sm-inline me-sm-3"
        style={{
          color: "#000000",
          fontWeight: "400",
          fontFamily: "Inter",
        }}
      >
        Privacy Policy
      </Link>
      <Link
        to="/term"
        className="text-muted text-decoration-none d-block d-sm-inline"
        style={{
          color: "#000000",
          fontWeight: "400",
          fontFamily: "Inter",
        }}
      >
        Terms & Conditions
      </Link>
    </div>
  </div>
</div>

      </footer>
    </div>
  );
};

export default Footer;
